import { Paper, styled, Tabs, TextField, Switch } from "@mui/material";

export const ScrollContainer = styled(Tabs)`
  span {
    background: transparent;
  }
  .MuiTabs-flexContainer {
    gap: 18px;
    padding: 20px;
  }
`;

export const MapStyleWrapper = styled(Paper)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  cursor: pointer;
  gap: 10px;
  padding: 10px;
  img {
    height: 100px;
    width: 80px;
  }
`;

export const StyledTextField = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    backgroundColor: "#ffffff",
    color: "#000000",
    borderRadius: "6px",
    fontSize: "16px",
    "& fieldset": {
      borderColor: "#ccc", // default border
    },
    "&:hover fieldset": {
      borderColor: "#aaa", // on hover
    },
    "&.Mui-focused fieldset": {
      borderColor: "#7ED957", // on focus
      borderWidth: "2px",
    },
  },
  "& .MuiInputLabel-root": {
    color: "#555555",
    backgroundColor: "#ffffff",
    paddingLeft: "4px",
    paddingRight: "4px",
  },
  "& .MuiInputLabel-shrink": {
    transform: "translate(14px, -6px) scale(0.75)",
  },
}));

export const StyledSwitch = styled(Switch)(({ theme }) => ({
  width: 52,
  height: 28,
  padding: 0,
  display: "flex",
  "&:active .MuiSwitch-thumb": {
    width: 22,
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(24px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: "#7ED957", // ✅ ON color
        opacity: 1,
        border: 0,
      },
    },
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: "#fff",
    width: 24,
    height: 24,
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
  },
  "& .MuiSwitch-track": {
    borderRadius: 28 / 2,
    backgroundColor: "#ccc", // Off color
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));
